/**
 *@author: Rahul Nainala
 *@Description : UI Screen for theme selection which takes the JSON file and renders it to the UI.
 **/
import { connect } from 'react-redux';
import { message } from 'antd';
import styles from '../../../commons/styles';
// import { Editor } from '@monaco-editor/react';
import React, { useState, useEffect } from 'react';

import { updateThemeFromEditor } from '../../../modules/actions/ThemeAction';
import blackThemeSettings from '../../../commons/styles/blackThemeSettings.json';
// import whiteThemeSettings from '../../../commons/styles/whiteThemeSettings.json';
import blueThemeSettings from '../../../commons/styles/blueThemeSettings.json';

const { StyledWrapper, StyledWrapperLeft, StyledWrapperRight } = styles.layout;

const Preferences = ({ updateThemeInRedux }) => {
    const [, setEditorContent] = useState(JSON.stringify(blackThemeSettings, null, 2));
    const [selectedColor, setSelectedColor] = useState('');

    // const handleEditorChange = (value) => setEditorContent(value);

    const colorThemeMapping = {
        "Black": { hex: "#000000", file: "black.json", themeData: blackThemeSettings },
        "Blue": { hex: "#1A3652", file: "default.json", themeData: blueThemeSettings },
        // "White": { hex: "rgb(244, 244, 244)", file: "white.json", themeData: whiteThemeSettings },
    };

    const colors = Object.entries(colorThemeMapping);

    useEffect(() => {
        setEditorContent(JSON.stringify(blackThemeSettings, null, 2));
    }, []);

    const handleColorSelect = async (colorHex) => {
        setSelectedColor(colorHex);
        const selectedTheme = Object.values(colorThemeMapping).find(theme => theme.hex === colorHex);
        if (selectedTheme) {
            try {
                setEditorContent(
                    JSON.stringify(selectedTheme.themeData, null, 2)
                );

                updateThemeInRedux(selectedTheme.themeData);
                message.success("Theme Updated Successfully");
            } catch (error) {
                message.error("Error Updating Theme");
                console.error("Failed to load theme data", error);
            }
        }
    };

    // const handleSave = () => {
    //     try {
    //         const updatedTheme = JSON.parse(editorContent);
    //         updateThemeInRedux(updatedTheme);
    //         message.success("Changes saved Successfully!!");
    //     } catch (error) {
    //         message.error("Invalid JSON!!");
    //         console.error("Invalid JSON :", error);
    //     }
    // };

    return (
        <div>
            <StyledWrapper>
                <StyledWrapperLeft>
                    <div>
                            Predefined Themes
                    </div>
                    <span >
                        Select one of the themes.
                    </span>
                </StyledWrapperLeft>
                <StyledWrapperRight>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(10, 1fr)', gap: '20px' }}>
                        {
                            colors.map(([name, { hex }], index) => (
                                <div key={index} style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => handleColorSelect(hex)}>
                                    <div
                                        style={{
                                            backgroundColor: hex,
                                            width: '60px',
                                            height: '60px',
                                            margin: '0 auto',
                                            border: hex === selectedColor ? '2px solid white' : 'none',
                                        }}
                                    />
                                    <span style={{ marginTop: '8px', display: 'block' }}>{name}</span>
                                </div>
                            ))
                            //  #e6f4ff
                        }
                    </div>
                </StyledWrapperRight>
            </StyledWrapper>
            {/* <StyledWrapper>
                <StyledWrapperLeft>
                    <div>
                        <span>
                            Theme JSON
                        </span>
                    </div>
                    <span>
                        Customize the Json for Themes.
                        For more customization please visit
                        <a href='https://ant.design/theme-editor?theme=dark' target='_blank' rel='noreferrer'>
                            https://ant.design/theme-editor?theme=dark
                        </a>
                        <br />
                        Make changes to JSON for changes.
                    </span>
                </StyledWrapperLeft>
                <StyledWrapperRight>
                    <div>
                        <Editor
                            height="500px"
                            theme='vs-dark'
                            defaultLanguage='json'
                            value={editorContent}
                            onChange={handleEditorChange}
                        />
                        <Button
                            type='primary'
                            onClick={handleSave}
                            style={{ marginTop: '20px', padding: '20px 20px' }}
                        >
                            Save JSON Theme Changes
                        </Button>
                    </div>
                </StyledWrapperRight>
            </StyledWrapper> */}
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
    updateThemeInRedux: updateTheme => dispatch(updateThemeFromEditor(updateTheme)),
});

export default connect(null, mapDispatchToProps)(Preferences);
